// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetSelfStudySectionComponentResponseByTypeHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SelfStudySectionComponentResponseDTO from '../models/SelfStudySectionComponentResponseDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    selfStudyId: string | null;
    selfStudyResponseTypeId: number;
    sectionIndex: number;
    componentIndex: number;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            selfStudyId: '00000000-0000-0000-0000-000000000000',
            selfStudyResponseTypeId: 0,
            sectionIndex: 0,
            componentIndex: 0,
        },
        initValues);
    },
    selfStudyId: 'selfStudyId',
    selfStudyResponseTypeId: 'selfStudyResponseTypeId',
    sectionIndex: 'sectionIndex',
    componentIndex: 'componentIndex',
}

interface Result extends ResultDTO {
    selfStudySectionComponentResponse: SelfStudySectionComponentResponseDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            selfStudySectionComponentResponse: null,
        },
        initValues);
    },
    selfStudySectionComponentResponse: 'selfStudySectionComponentResponse',
}

export { Request, Result };